
import React, { memo } from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import GridContainer from "src/components/Grid/GridContainer.jsx";
import GridItem from "src/components/Grid/GridItem.jsx";

import * as model from '../../data/model';
import Button from "src/components/CustomButtons/Button.jsx";
import CloseIcon from '@material-ui/icons/Close';
import { Card, IconButton, FormControl,CardHeader, CardActions, CardMedia, CardActionArea, CardContent, Typography, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText } from "@material-ui/core";
import CardIcon from "src/components/Card/CardIcon.jsx";
import CustomInput from "src/components/CustomInput/CustomInput.jsx";
import * as track from '../../data/track/track';

import * as types from '../../types'

import manualImage from "../../assets/img/manual-gearbox-stick-shift.jpg";
import rssImage from "../../assets/img/rss.jpg"; 
import { PodCastType, Track } from "functions/lib/data/model";
import { type } from "os";
const styles: any = theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit,
        top: theme.spacing.unit,
        color: theme.palette.grey[500],
      },
    card: {
       width:'100%',
       height:'100%'
      },
      media: {
        height: 140,
      },
});
let helper = new types.ValidationHelper();
helper.fields = [
    {
        field: 'rssUrl',
        rules: [new types.RequiredRule(),new types.UrlRule()]
    }

];

enum modalMode {type,url,validate};

interface PodcastTypeProps {
    classes: any;
    connect: types.IState,
    open: boolean;
    podcastUrl?:string;

    close: () => void;  
}
interface PodcastTypeState {
    validatingRss:boolean;
    errors: Array<types.ValidationError>;
    fieldCheck: any;
    mode:modalMode;
    rssUrl:string;
    validateRssFeedReponse?:model.ValidateRssFeedReponse,
  
}
let defaultState = {
    validatingRss:false,
    errors:new Array<types.ValidationError>(),
    fieldCheck:{},
    rssUrl:undefined,
    mode:modalMode.type,

}
class PodCastTypeDialog extends React.Component<PodcastTypeProps, PodcastTypeState> {


    constructor(props: PodcastTypeProps) {
        super(props);
      
        this.state = {...defaultState}

    }
    componentWillReceiveProps(props: PodcastTypeProps) {
        let me = this;
        if (props.open && !this.props.open) {
            track.Track.ModelView("PodcastTypeModal")
            let state = {...defaultState}
            debugger;
            if(props.podcastUrl){
                state.mode = modalMode.url;
                state.rssUrl = props.podcastUrl;
                setTimeout(()=>{
                    me.processUrl(null)
                },10)
            }
            this.setState({...state})
           

        }

    }
    async processUrl(e:any)
    {
            try
            {
                let s ={...this.state}
                s.validatingRss = true;
                this.setState(s);
                s={...this.state};
                s.validatingRss = false;
                s.validateRssFeedReponse =  await this.props.connect.lo_ctx.val().PodCast.validateRssFeed(this.state.rssUrl);
                 
                s.mode =modalMode.validate;
                 this.setState(s);

            }
            catch(e)
            {
                let s={...this.state};
                s.validatingRss = false;
                this.setState(s);
                track.Track.reportError(e,"Hmmm.  Could not find the RSS feed for this blog.",true,this.props.connect.dispatch)
            }
    }
    async createPodcast(){
        try{
            let podcast = {...this.state.validateRssFeedReponse.podcast}
            podcast.id = this.props.connect.lo_ctx.val().generateNewId();
            podcast.is_new = true;
            podcast.podcast_type = model.PodCastType.rss;
            podcast.feed_status = model.PodCastFeedStatus.ready;
            podcast = await this.props.connect.lo_ctx.val().PodCast.save(podcast);
            podcast.feed_status = model.PodCastFeedStatus.dirty;
            await this.props.connect.lo_ctx.val().PodCast.save(podcast);
            this.props.connect.lo_ctx.val().PodCast.sync(podcast.id);
            types.ViewState.navigate(types.ViewState.hashPodCastView(podcast.id))

        }
        catch(e){
            track.Track.reportError(e,"Error Creating PodCast",true,this.props.connect.dispatch)
        }
    }
    render() {
        const { classes } = this.props;
        let me = this;
        let isMobile = true;
        let errors = helper.validateForm(this.state).errors;
        let hasErrors = errors.length > 0 && this.state.mode  == modalMode.url;
        console.log('has errors ' + hasErrors)
        console.log(JSON.stringify(errors ))

        return (
            <Dialog
                fullWidth={true}
                maxWidth="md"
                open={this.props.open}
              
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" >{'New Podcast'}
                <IconButton aria-label="Close" className={classes.closeButton} onClick={this.props.close}>
          <CloseIcon />
        </IconButton>
                </DialogTitle>
                {this.state.mode == modalMode.type  && 
                <DialogContent>
                   
                    <DialogContentText>

                        <div>Please select how content will be added to this Podcast.</div>
                        <div><br/></div>

                        <GridContainer justify="center" alignItems="center"
                        >
                            
                            <GridItem xs={12} sm={6} md={6} lg={6       }>
                                <Card className={classes.card} onClick={(e)=>{
                                    let s = {...me.state};
                                    s.mode = modalMode.url;
                                    me.setState(s);
                                }}>
                                    <CardActionArea>
                                        <CardMedia
                                            className={classes.media}
                                            image={rssImage}
                                            title="Manually"
                                        />
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                Automatic
          </Typography>
                                            <Typography component="p">
                                            I want Castablog to monitor a blog or website and automatically create podcast espisodes.
         
         
          </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                   
                                </Card>
                            </GridItem>
                            <GridItem xs={12} sm={4} md={4} lg={4}>
                                <Card className={classes.card} onClick={(e)=>{
                                    types.ViewState.navigate(types.ViewState.hashPodCastEdit('new'))
                                }}>
                                    <CardActionArea>
                                        <CardMedia
                                            className={classes.media}
                                            image={manualImage}
                                            title="Manually"
                                        />
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                Manual
          </Typography>
                                            <Typography component="p">
                                               I want to manually add each espisode by providing a url to a page/article or supplying text.
                                               
          </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                    
                                </Card>
                            </GridItem>

                        </GridContainer>




                    </DialogContentText>
                   
               </DialogContent>
                }
                 {this.state.mode == modalMode.url && 
               <DialogContent>
                   
                   <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput

                                        labelText="Enter the Url or RSS feed Url of the blog you want to make a podcast for."
                                        id="url"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        helpText={helper.getFirstError('rssUrl', this.state.errors)}
                                        success={this.state.fieldCheck['rssUrl'] && !helper.getFirstError('rssUrl', this.state.errors)}
                                        error={helper.getFirstError('rssUrl', this.state.errors)}

                                        disable={this.state.validatingRss}
                                        value={this.state.rssUrl?this.state.rssUrl:this.props.podcastUrl}
                                        inputProps={{
                                            disable:this.state.validatingRss,
                                            onChange: (e) => {
                                                let s = {...me.state};
                                                s.rssUrl = e.target.value;
                                                me.setState(s);

                                            },
                                            value:this.state.rssUrl?this.state.rssUrl:this.props.podcastUrl,
                                            onKeyDown: (e) => {


                                                if (e.which === 13) {
                                                    {
                                                        e.stopPropagation();
                                                        if (!hasErrors)
                                                            me.processUrl(e)
                                                        return false;
                                                    }

                                                }
                                            }
                                        }}
                                    />
                                </GridItem>
                              
                                <GridItem xs={12} >
                                    <div style={{
                                        'display': 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '50px'
                                    }}>
                                        <Button
                                            color="rose"
                                            onClick={this.processUrl.bind(this)}
                                            variant="contained"
                                            disabled={this.state.validatingRss || hasErrors}

                                            className={classes.registerButton}
                                        >
                                            {this.state.validatingRss && (
                                                <span>Grabbing Contents...</span>
                                            )
                                            }

                                            {!this.state.validatingRss && (
                                                <span>Create Podcast</span>
                                            )}
                                        </Button>
                                    </div>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    </DialogContent>
                 }
                {this.state.mode == modalMode.validate && 
 <DialogContent>
                   
 <GridContainer>
      <GridItem xs={12} sm={12} md={12} style={{fontSize:'18px'}}>
       
      <div style={{
                                        'display': 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        
                                    }}>
                                        <img style={{    padding: '10px'}} src={this.state.validateRssFeedReponse.podcast.image_url} width='80px' height='80px' />
                                    
                               
                                     <span>- {this.state.validateRssFeedReponse.podcast.title} found <strong>{this.state.validateRssFeedReponse.tracks.length}</strong> tracks.</span>
                                     </div>
              </GridItem>
             
            
              <GridItem xs={12} >
                  <div style={{
                      'display': 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    
                  }}>
                      <Button
                          color="rose"
                          onClick={this.createPodcast.bind(this)}
                          variant="contained"
                          disabled={this.state.validatingRss || hasErrors}

                          className={classes.registerButton}
                      >
                          {this.state.validatingRss && (
                              <span>Creating Podcast...</span>
                          )
                          }

                          {!this.state.validatingRss && (
                              <span>Create Podcast</span>
                          )}
                      </Button>
                  </div>
              </GridItem>
          </GridContainer>
  

  </DialogContent>

                }
            </Dialog>

        );
    }
}

export function mapStateToProps(state: types.IState) {
    return {
        connect: state
    };
}
export default connect(
    mapStateToProps,
    null
)(withStyles(styles as any)(PodCastTypeDialog));







// WEBPACK FOOTER //
// ./src/views/podcast/PodCastTypeDialog.tsx